





























































































































































































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import AbpBase from '@/lib/abpbase'
    import Util from '@/lib/util'
    import warehousequest from '@/store/entities/warehouseinfodetail'
    import getOrderStatistics from '@/store/entities/user-order-statistics'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    import { routers } from '@/router/router'

    @Component
    export default class Home extends AbpBase {
        warehouseInfodetailList: Array<warehousequest> = [];
        fillterwarehouseInfodetailList: Array<warehousequest> = [];
        getOrderStatisticsquest: getOrderStatistics = new getOrderStatistics();
        phone: string = "";
        userName: string;
        isDisplay: boolean = true;
        async created() {

            var a = this.hasPermission("OrderManage.MainLandOrderManage");
            var b = this.hasPermission("OrderManage.MainLandOrderManage.FreightCost");
            if (a == true && b == false) {
                this.isDisplay = false;
            }
            else {
                await this.getpage();
            }
        }
        data() {
            return {
                split3: 0.6,
                split4: 0.7
            }
        }
        async getpage() {

            this.fillterwarehouseInfodetailList = await this.$store.dispatch({
                type: 'warehouseInfoDetail/getAll',
                data: {}
            });
            var _this = this;
            this.fillterwarehouseInfodetailList.forEach(function (item, index) {
                if (item.orderType == "本土") {
                    _this.warehouseInfodetailList.push(item);
                }
            })
            this.getOrderStatisticsquest = await this.$store.dispatch({
                type: 'fontorder/getOrderStatistics',
                data: {}
            });
            this.userName = this.warehouseInfodetailList[0].userCode;
            this.phone = this.warehouseInfodetailList[0].phone;
        }


    }
